import { Heading3 } from "components/Heading3";
import { Link } from "components/Link";
import { PrismicRichText } from "@prismicio/react";
import { SrcSet } from "components/SrcSet";
import { StrongLink } from "components/StrongLink";
import styles from "./LinkedItems.module.css";

export const LinkedItemsWrapper = ({ primary, items }) => {
  const mappedItems = items.map(({ image, link, item_title, text }) => ({
    image,
    link,
    title: item_title,
    text,
  }));
  return (
    <LinkedItems
      title={primary.title}
      items={mappedItems}
      link={primary.link}
      linkLabel={primary.link_label}
    />
  );
};

export const LinkedItems = ({ title, items, link, linkLabel }) => (
  <div>
    {title && <Heading3 as="h2">{title}</Heading3>}
    <div className={styles.itemsContainer}>
      {items.map(({ image, link, title, text }) => (
        <LinkedItemCard
          key={title}
          title={title}
          text={text}
          link={link}
          image={{ alt: image.alt, src: image.url }}
        />
      ))}
    </div>
    {link && linkLabel && (
      <div className={styles.strongLinkContainer}>
        <StrongLink link={link}>{linkLabel}</StrongLink>
      </div>
    )}
  </div>
);

const LinkedItemCard = ({
  image,
  link: { link_type, url, uid, type },
  title,
  text,
}) => {
  return (
    <Link className={styles.item} {...{ link_type, url, uid, type }}>
      {image.src && (
        <div className={styles.imageContainer}>
          <SrcSet
            className={styles.image}
            alt={image.alt}
            src={image.src}
            sizes={[{ ratio: 1, minWidth: 1, width: 72 }]}
            cropCenter={undefined}
          />
        </div>
      )}
      <div className={styles.container}>
        <h4 className={styles.title}>{title}</h4>
        {text.length ? (
          <div className={styles.richText}>
            <PrismicRichText field={text} />
          </div>
        ) : null}
      </div>
    </Link>
  );
};
